import request from '../utils/Request';
import { Methods } from '../config';
import { downloadFile } from '../utils/download';

const baseURL = 'dynamicForm';

const dynamicFormService = {
  getFile: async (id, filename) => {
    const file = await request({
      responseType: 'blob',
      resource: `${baseURL}/getFile/${encodeURIComponent(id)}`,
    });
    return downloadFile(file, filename);
  },

  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  getItem: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  getWorksheet: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/worksheet/${encodeURIComponent(id)}`,
    });
  },

  getSelectViews: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/select-views`,
    });
  },

  getWorksheetReportForms: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/worksheet-report/forms`,
    });
  },

  getWorksheetReport: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/worksheet-report/${encodeURIComponent(id)}`,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  uploadFile: (id, files) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    return request({
      method: Methods.POST,
      resource: `${baseURL}/uploadFile/${encodeURIComponent(id)}`,
      formData: true,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  deleteFile: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/deleteFile/${encodeURIComponent(id)}`,
    });
  },

  addForm: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/addForm`,
      data,
    });
  },
};

export default dynamicFormService;
